import React from 'react';
export class MultiselectValue extends React.Component {
    constructor(props) {
        super(props);
    }

    className(){
        if(this.props.isSelected){
            return "bi bi-check-circle";
        }
        return "bi bi-circle";
    }

    renderTitle(){
        return this.props.Title
    }

    render(){
        return (
            <div className="col-xl-6 value mt-3" onClick={(e) => {this.props.collectMultiSelectData(this.props.state, this.props.ID, !this.props.isSelected)}}>
                <i className={this.className()}/>
                <button type="button" className="ms-2">
                    {this.renderTitle()}
                </button>
            </div>
        )
    }
}
export default MultiselectValue;
